import { render, staticRenderFns } from "./SkillLabel.vue?vue&type=template&id=26e7f160&scoped=true"
import script from "./SkillLabel.vue?vue&type=script&lang=ts"
export * from "./SkillLabel.vue?vue&type=script&lang=ts"
import style0 from "./SkillLabel.vue?vue&type=style&index=0&id=26e7f160&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26e7f160",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('26e7f160')) {
      api.createRecord('26e7f160', component.options)
    } else {
      api.reload('26e7f160', component.options)
    }
    module.hot.accept("./SkillLabel.vue?vue&type=template&id=26e7f160&scoped=true", function () {
      api.rerender('26e7f160', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/skills/SkillLabel.vue"
export default component.exports